import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';

import CardDialog from '~/components/CardDialog';
import Grid from '~/components/core/Atomic/Grid/Grid';
import DialogFooterActions from '~/components/core/DialogFooterActions';
import RadioButtonGroupFormik from '~/components/core/Formik/RadioButtonGroupFormik';
import Text from '~/components/core/TextComponents/Text';

import {
  CAP_RECOVERIES_MODE_OPTIONS,
  CAP_RECOVERIES_MODES,
  isCapEnforcementOn,
  PAYMENTS_CONFIG_FIELDS,
} from '../constants';

export const CAP_RECOVERIES_MODE_FORM_FIELD = 'cap_recoveries_mode';

const VALIDATION_SCHEMA = Yup.object().shape({
  [CAP_RECOVERIES_MODE_FORM_FIELD]: Yup.string()
    .oneOf([CAP_RECOVERIES_MODES.WARN, CAP_RECOVERIES_MODES.BLOCK])
    .required(),
});

const CapRecoveriesConfigurationDialog = ({ paymentsConfiguration, disabled = false, onCancel, onSubmit }) => {
  const currentMode = paymentsConfiguration?.[PAYMENTS_CONFIG_FIELDS.CAP_RECOVERIES_AT_TOTAL_PAID];
  const initialMode = isCapEnforcementOn(currentMode) ? currentMode : CAP_RECOVERIES_MODES.WARN;

  return (
    <Formik
      initialValues={{ [CAP_RECOVERIES_MODE_FORM_FIELD]: initialMode }}
      validationSchema={VALIDATION_SCHEMA}
      onSubmit={async (values, formikProps) => {
        try {
          await onSubmit(values);
        } catch (error) {
          formikProps.setSubmitting(false);
        }
      }}
    >
      {({ handleSubmit, isSubmitting }) => (
        <CardDialog
          title="Cap Recoveries at Total Paid"
          isDialog
          maxWidth="sm"
          fullWidth
          onClose={onCancel}
          preventClose={disabled || isSubmitting}
          footerActions={
            <DialogFooterActions
              disabled={disabled || isSubmitting}
              onClickPrimary={handleSubmit}
              onClickSecondary={onCancel}
              primaryLabel="Save"
              secondaryLabel="Cancel"
            />
          }
        >
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR}>
                Prevent total recoveries from exceeding total paid (indemnity + expenses).
              </Text>
            </Grid>
            <Grid item xs={12}>
              <RadioButtonGroupFormik
                label="Enforcement"
                id={CAP_RECOVERIES_MODE_FORM_FIELD}
                direction="column"
                options={CAP_RECOVERIES_MODE_OPTIONS}
                variant="subtitle1"
              />
            </Grid>
          </Grid>
        </CardDialog>
      )}
    </Formik>
  );
};

CapRecoveriesConfigurationDialog.propTypes = {
  paymentsConfiguration: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

export default CapRecoveriesConfigurationDialog;
